// extracted by mini-css-extract-plugin
module.exports = {"StockStampLink":"StockStampLink_StockStampLink__RLXqG"};